import React, { useState } from "react";
import { Button } from "@mui/material";

// ICONS

import arrowRightIcon from "../../images/arrowRight.png";
import arrowLeftIcon from "../../images/arrowLeft.png";

const containerStyle = {
  width: "100%",
  maxWidth: "500px",
  margin: "0",
  textAlign: "left",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  position: "relative",
  minHeight: "610px",
  fontFamily: "Montserrat",
};



const headerStyle = {
  marginTop: "10px",
  display: "flex",
  alignItems: "center", // Vertically centers icon with text
  gap: "12px",
};

const titleStyle = {
  fontSize: "20px",
  fontWeight: 600,
  lineHeight: "1", // Set to 1 to prevent extra vertical padding from interfering with icon alignment
};

const subtitleStyle = {
  marginTop: "6px", // Space between the Icon/Title row and the Subtitle
  fontSize: "14px",
  color: "rgba(0,0,0,0.7)",
};

const iconContinueBtnStyle = {
  position: "absolute",
  bottom: "20px",
  right: "0",
  width: "53px",
  height: "53px",
  borderRadius: "50%",
  background:
    "linear-gradient(rgba(255,255,255,0.2), rgba(255,255,255,0.2)), linear-gradient(90deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
};

const buttonContinueWrapperStyle = {
  position: "absolute",
  bottom: "20px",
  right: "0",
};

const continueBtnStyle = {
  position: "absolute",
  bottom: "20px",
  right: "0",
  //   width: "53px",
  height: "53px",
  //   borderRadius: "50%",
  //   background:
  //     "linear-gradient(rgba(255,255,255,0.2), rgba(255,255,255,0.2)), linear-gradient(90deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
};

const stepTextStyle = {
  position: "absolute",
  bottom: "32px",
  left: "0",
  fontSize: "15px",
  fontWeight: 500,
};

const figmaContinueBtn = {
  width: 200,
  height: 50,
  position: "relative",
  cursor: "pointer",
  textAlign: "center",
  fontSize: 18,
  color: "#fff",
  fontFamily: "Montserrat",
};

const figmaContinueBg = {
  position: "absolute",
  top: 0,
  left: 0,
  borderRadius: 13,
  background:
    "linear-gradient(rgba(255,255,255,0.2), rgba(255,255,255,0.2)), linear-gradient(90deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))",
  width: "100%",
  height: "100%",
};

const figmaContinueText = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  lineHeight: "150%",
  fontWeight: 600,
  whiteSpace: "nowrap",
};

const RegistrationStepLayout = ({
  icon,
  title,
  subtitle,
  stepText,
  onBack,
  onContinue,
  children,

  continueVariant = "icon",
  rightHeaderContent,
}) => {
  return (
    <div style={containerStyle}>
      {/* BACK + HEADER */}
      {onBack && (
        <img
          src={arrowLeftIcon}
          alt="Back"
          width={22}
          style={{ cursor: "pointer", marginRight: "8px" }}
          onClick={onBack}
        />
      )}



      <div
      style={{width: "100%",}}
      >
        {/* Flex container for Icon + Title only */}

        <div
  style={{
    ...headerStyle,
    justifyContent: "space-between",
    width: "100%",
  }}
>
  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
    <img src={icon} alt="" width={30} height={30} />
    <div style={titleStyle}>{title}</div>
  </div>

  {rightHeaderContent && rightHeaderContent}
</div>
        {/* <div style={headerStyle}>
          <img src={icon} alt="" width={30} height={30} />
          <div style={titleStyle}>{title}</div>
        </div> */}

        {/* Subtitle placed below the row */}
        <div style={subtitleStyle}>{subtitle}</div>
      </div>

      {/* STEP CONTENT */}
      {children}

      {/* STEP TEXT */}
      <div style={stepTextStyle}>{stepText}</div>

      {/* CONTINUE BUTTON */}
      <div
        style={
          continueVariant === "icon"
            ? iconContinueBtnStyle
            : buttonContinueWrapperStyle
        }
        onClick={onContinue}
      >
        {continueVariant === "icon" ? (
          <img src={arrowRightIcon} alt="" width={23} />
        ) : (
          <div style={figmaContinueBtn}>
            <div style={figmaContinueBg} />
            <div style={figmaContinueText}>Continue</div>
          </div>
        )}
      </div>

    
    </div>
  );
};

export default RegistrationStepLayout;
